import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { updateUser } from '@services/users.service';
import { USERS_QUERY_KEY } from './useUsers';
import { USER_DETAIL_QUERY_KEY } from './useUserDetail';

export const useUpdateUser = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, body }) => updateUser(id, body),
        onSuccess: (_data, variables) => {
            const userId = variables?.id;
            message.success('User updated successfully');
            if (userId) {
                queryClient.invalidateQueries({ queryKey: USERS_QUERY_KEY });
                queryClient.invalidateQueries({ queryKey: USER_DETAIL_QUERY_KEY(userId) });
            } else {
                queryClient.invalidateQueries({ queryKey: USERS_QUERY_KEY });
            }
        },
        onError: (error) => {
            const errMsg = error?.response?.data?.message || error?.message || 'Failed to update user';
            message.error(errMsg);
        },
    });
};

